// src/components/common/FeatureCard.js
import React from 'react';
import { Box, Typography } from '@mui/material';

// 기존 '이모지 + 텍스트' 카드를 대체하는 풀블리드 카드.
// image가 있으면 사진 배경, 없으면 gradient(또는 단색)로 채웁니다.
// icon을 넘기면 사진/그라데이션 위 상단에 아이콘을 함께 보여줍니다.
const FeatureCard = ({ image, gradient, icon, title, description }) => (
  <Box
    sx={{
      position: 'relative',
      borderRadius: '12px',
      overflow: 'hidden',
      height: 240,
      backgroundImage: image ? `url(${image})` : 'none',
      background: !image ? (gradient || '#e5e7eb') : undefined,
      backgroundColor: image ? undefined : (gradient ? undefined : '#e5e7eb'),
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
      transition: 'transform 0.2s ease',
      '&:hover': { transform: 'translateY(-4px)' }
    }}
  >
    {image && (
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          background: 'linear-gradient(180deg, rgba(0,0,0,0) 35%, rgba(0,0,0,0.75) 100%)'
        }}
      />
    )}

    {icon && (
      <Box sx={{ position: 'relative', p: 2.5, color: 'white' }}>
        <Box sx={{ fontSize: 36, lineHeight: 1, opacity: 0.95 }}>{icon}</Box>
      </Box>
    )}

    <Box sx={{ position: 'relative', p: 2.5, color: 'white', mt: icon ? 0 : 'auto' }}>
      <Typography
        variant="h6"
        sx={{ fontWeight: 600, mb: 0.5, textShadow: '1px 1px 4px rgba(0,0,0,0.6)' }}
      >
        {title}
      </Typography>
      <Typography variant="body2" sx={{ textShadow: '1px 1px 3px rgba(0,0,0,0.6)' }}>
        {description}
      </Typography>
    </Box>
  </Box>
);

export default FeatureCard;

